import { SearchFromPageType } from '../../models/SearchFromPageType';

export const getTypedCurrentPage = (currentPageString?: string) => {
    const isEnum: boolean =
        !!currentPageString &&
        Object.values(SearchFromPageType)
            .map((item) => item.toLocaleLowerCase())
            .includes(currentPageString.toLowerCase() as SearchFromPageType);

    const searchFromPage = isEnum
        ? (currentPageString as SearchFromPageType)
        : SearchFromPageType.Other;

    return searchFromPage;
};
